import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", ""));
    const session_id = params.get("session_id");
    if (!session_id) { navigate("/"); return; }

    api.post("/auth/session", { session_id })
      .then(async () => {
        await refresh();
        // Check if user_type is set; if not, redirect to home with a flag so the picker shows
        try {
          const me = await api.get("/me/profile");
          if (!me.data.user_type) {
            window.location.replace("/?need_user_type=1");
            return;
          }
          // Route based on role
          const dest = me.data.user_type === "buyer" ? "/dashboard" : "/";
          window.location.replace(dest);
        } catch {
          window.location.replace("/");
        }
      })
      .catch(() => { navigate("/"); });
  }, [navigate, refresh]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-gold border-t-transparent rounded-full animate-spin mx-auto"></div>
        <p className="mt-4 text-sm text-muted-foreground">Signing you in...</p>
      </div>
    </div>
  );
}
